import { create } from 'zustand';
const initialState = {
    lifeDomains: [],
};
export const useLifeDomainsStore = create((set) => ({
    ...initialState,
    setLifeDomains: (lifeDomains) => set({ lifeDomains }),
    reset: () => set(initialState),
}));
export const selectLifeDomainById = (state, id) => state.lifeDomains.find((domain) => domain.id === id);
